const LOCK = 'Lock';
const MUTE = 'mute';
const SHARE = 'share';
const MESSAGE = 'message';
const RENAME = 'rename';
const MICRO = 'micro';
const CAMERA = 'camera';
const CREATE_ACCOUNT = 'create_account';
const DELETE_ACCOUNT = 'delete_account';
const EDIT_ACCOUNT = 'edit_account';
const GET_ACCOUNT = 'get_account';
const CREATE_ROOM = 'create_room';
const EDIT_ROOM = 'edit_room';
const GET_ROOM = 'get_room';
const DELETE_ROOM = 'delete_room';
const GET_GROUP_ROLE = 'get_groupRole';
const EDIT_GROUP_ROLE = 'edit_groupRole';
const CREATE_GROUP_ROLE = 'create_groupRole';
const DELETE_GROUP_ROLE = 'delete_groupRole';
const GET_FUNCTION = 'get_function';
const UPDATE_FUNCTION = 'update_function';
const MANAGE_ROOM = 'manage_room';
const MANAGER_CONFIG_SYSTEM = 'manager_config_system';
const MANAGER_HISTORY = 'manager_history';
// const MANAGER_RECORDINGS = 'manager_recordings';
const EDIT_CONTENT_LANDINGPAGE = 'edit_content_landingpage';

const FUNCTIONS = {
    MANAGE_USER_VIEW: {
        code: 'MANAGE_USER_VIEW',
    },
    MANAGE_USER_EDIT: {
        code: 'MANAGE_USER_EDIT',
    },
    MANAGE_USER_IMPORT_XLSX: {
        code: 'MANAGE_USER_IMPORT_XLSX',
    },
    MANAGE_USER_RESETPASSWORD: {
        code: 'MANAGE_USER_RESETPASSWORD',
    },
    MANAGE_USER_PASSWORD_CHANGE: {
        code: 'MANAGE_USER_PASSWORD_CHANGE'
    },
    MANAGE_SIP_ACCOUNT_VIEW: {
        code: 'MANAGE_SIP_ACCOUNT_VIEW',
    },
    MANAGE_SIP_ACCOUNT_EDIT: {
        code: 'MANAGE_SIP_ACCOUNT_EDIT',
    },
    MANAGE_MEETING_MONITOR_VIEW: {
        code: 'MANAGE_MEETING_MONITOR_VIEW',
    },
    MANAGE_WHITEBOARD_VIEW: {
        code: 'MANAGE_WHITEBOARD_VIEW',
    },
    MANAGE_WHITEBOARD_EDIT: {
        code: 'MANAGE_WHITEBOARD_EDIT',
    },
    MANAGE_WHITEBOARD_CREATE_LIMIT: {
        code: 'MANAGE_WHITEBOARD_CREATE_LIMIT',
    },
    MANAGE_SUBTITLE_PERSONAL_VIEW: {
        code: 'MANAGE_SUBTITLE_PERSONAL_VIEW'
    },
    MANAGE_SUBTITLE_ORGANIZATION_VIEW: {
        code: 'MANAGE_SUBTITLE_ORGANIZATION_VIEW'
    },
    MANAGE_SUBTITLE_CONTENT_VIEW: {
        code: 'MANAGE_SUBTITLE_CONTENT_VIEW'
    },
    MANAGE_SUBTITLE_EDIT: {
        code: 'MANAGE_SUBTITLE_EDIT'
    },
    MANAGE_RECORDING_PERSONAL_VIEW: {
        code: 'MANAGE_RECORDING_PERSONAL_VIEW'
    },
    MANAGE_RECORDING_ORGANIZATION_VIEW: {
        code: 'MANAGE_RECORDING_ORGANIZATION_VIEW'
    },
    MANAGE_RECORDING_PLAY: {
        code: 'MANAGE_RECORDING_PLAY'
    },
    MANAGE_RECORDING_EDIT: {
        code: 'MANAGE_RECORDING_EDIT'
    },
    MANAGE_MEETING_PERSIONAL_VIEW: {
        code: 'MANAGE_MEETING_PERSIONAL_VIEW'
    },
    MANAGE_MEETING_ORGANIZATION_VIEW: {
        code: 'MANAGE_MEETING_ORGANIZATION_VIEW'
    },
    MANAGE_MEETING_SCHEDULE_EDIT: {
        code: 'MANAGE_MEETING_SCHEDULE_EDIT'
    },
    MANAGE_ROLE_VIEW: {
        code: 'MANAGE_ROLE_VIEW'
    },
    MANAGE_ROLE_EDIT: {
        code: 'MANAGE_ROLE_EDIT'
    },
    MANAGE_FUNCTION_VIEW: {
        code: 'MANAGE_FUNCTION_VIEW'
    },
    MANAGE_FUNCTION_EDIT: {
        code: 'MANAGE_FUNCTION_EDIT'
    },
    MANAGE_ORGANIZATION_VIEW: {
        code: 'MANAGE_ORGANIZATION_VIEW'
    },
    MANAGE_ORGANIZATION_EDIT: {
        code: 'MANAGE_ORGANIZATION_EDIT'
    },
    // Cấu hình - manage-systems
    MANAGE_SYSTEM_PARAMETER_VIEW: {
        code: 'MANAGE_SYSTEM_PARAMETER_VIEW'
    },
    MANAGE_SYSTEM_PARAMETER_EDIT: {
        code: 'MANAGE_SYSTEM_PARAMETER_EDIT'
    },
    MANAGE_UNIT_VIEW: {
        code: 'MANAGE_UNIT_VIEW'
    },
    MANAGE_UNIT_EDIT: {
        code: 'MANAGE_UNIT_EDIT'
    },
    MANAGE_UNIT_POSITION_VIEW: {
        code: 'MANAGE_UNIT_POSITION_VIEW'
    },
    MANAGE_UNIT_POSITION_EDIT: {
        code: 'MANAGE_UNIT_POSITION_EDIT'
    },
    // -----
    MANAGE_SYSTEM_LOG_VIEW: {
        code: 'MANAGE_SYSTEM_LOG_VIEW'
    },
    MANAGE_CUSTOMER_LICENSE_VIEW: {
        code: 'MANAGE_CUSTOMER_LICENSE_VIEW'
    },
    MANAGE_LIMIT_CONCURRENT_MEETING: {
        code: 'MANAGE_LIMIT_CONCURRENT_MEETING'
    },
    MANAGE_CALL_SIP: {
        code: 'MANAGE_CALL_SIP',
        scope: 'SIP'
    },
    MEETING_DURATION_LIMIT: {
        code: 'MEETING_DURATION_LIMIT'
    },
    MEETING_PARTICIPANTS_LIMIT: {
        code: 'MEETING_PARTICIPANTS_LIMIT'
    },
    MANAGER_EVENT: {
        code: 'MANAGER_EVENT'
    },
    MANAGE_CONTACTS_VIEW: {
        code: 'MANAGE_CONTACTS_VIEW'
    },
    MANAGER_BACKUP_VIEW: {
        code: 'MANAGER_BACKUP_VIEW'
    },
    MANAGER_BACKUP_EDIT: {
        code: 'MANAGER_BACKUP_EDIT'
    },
    MANAGER_VERSION_VIEW: {
        code: 'MANAGER_VERSION_VIEW'
    },
    MANAGER_VERSION_EDIT: {
        code: 'MANAGER_VERSION_EDIT'
    },
    MANAGER_BRANDING_VIEW: {
        code: 'MANAGER_BRANDING_VIEW'
    },
    MANAGER_BRANDING_EDIT: {
        code: 'MANAGER_BRANDING_EDIT'
    },
    MANAGER_FUNCTION_MCU: {
        code: 'MANAGER_FUNCTION_MCU'
    },
    MCU_CONTROL_ROOM_CONTROL: {
        code: 'MCU_CONTROL_ROOM_CONTROL'
    },
    MCU_CONTROL_ROOM_MONITOR: {
        code: 'MCU_CONTROL_ROOM_MONITOR'
    },
    MCU_CONTROL_ROOM_EDIT: {
        code: 'MCU_CONTROL_ROOM_EDIT'
    },
    MCU_CONTROL_ROOM_VIEW: {
        code : 'MCU_CONTROL_ROOM_VIEW'
    },
    // MCU_SETTINGS_ROOM_EDIT: {
    //     code: 'MCU_SETTINGS_ROOM_EDIT'
    // },
    // MCU_SETTINGS_ROOM_VIEW: {
    //     code : 'MCU_SETTINGS_ROOM_VIEW'
    // },
    MCU_CONTROL_SIP_ACCOUNT_VIEW: {
        code: "MCU_CONTROL_SIP_ACCOUNT_VIEW"
    },
    MCU_CONTROL_SIP_ACCOUNT_EDIT: {
        code: 'MCU_CONTROL_SIP_ACCOUNT_EDIT'
    }
}

const ROLES = [
    {
        isAuthen: false,
        name: LOCK,
    },
    {
        isAuthen: false,
        name: MUTE,
    },
    {
        isAuthen: false,
        name: SHARE,
    },
    {
        isAuthen: false,
        name: MESSAGE,
    },
    {
        isAuthen: false,
        name: RENAME,
    },
    {
        isAuthen: false,
        name: MICRO,
    },
    {
        isAuthen: false,
        name: CAMERA,
    },
    {
        isAuthen: false,
        name: CREATE_ACCOUNT,
    },
    {
        isAuthen: false,
        name: DELETE_ACCOUNT,
    },
    {
        isAuthen: false,
        name: EDIT_ACCOUNT,
    },
    {
        isAuthen: false,
        name: GET_ACCOUNT,
    },
    {
        isAuthen: false,
        name: CREATE_ROOM,
    },
    {
        isAuthen: false,
        name: EDIT_ROOM,
    },
    {
        isAuthen: false,
        name: GET_ROOM,
    },
    {
        isAuthen: false,
        name: DELETE_ROOM,
    },
    {
        isAuthen: false,
        name: GET_GROUP_ROLE,
    },
    {
        isAuthen: false,
        name: EDIT_GROUP_ROLE,
    },
    {
        isAuthen: false,
        name: CREATE_GROUP_ROLE,
    },
    {
        isAuthen: false,
        name: DELETE_GROUP_ROLE
    },
    {
        isAuthen: false,
        name: GET_FUNCTION
    },
    {
        isAuthen: false,
        name: UPDATE_FUNCTION
    },
    {
        isAuthen: false,
        name: MANAGE_ROOM
    },
    {
        isAuthen: false,
        name: MANAGER_CONFIG_SYSTEM
    },
    {
        isAuthen: false,
        name: MANAGER_HISTORY
    }
]

const GROUP_MEMBER_ROLES = {
    1: 'owner',
    2: 'admin',
    3: 'member'
}

const GROUP_MEMBER_STATUS = {
    1: 'active',
    3: 'left',
    4: 'removed'
}

export {
    GROUP_MEMBER_ROLES,
    GROUP_MEMBER_STATUS,
    ROLES,
    LOCK,
    MUTE,
    SHARE,
    MESSAGE,
    RENAME,
    MICRO,
    CAMERA,
    GET_ROOM,
    EDIT_ROOM,
    DELETE_ROOM,
    CREATE_ROOM,
    CREATE_ACCOUNT,
    EDIT_ACCOUNT,
    GET_ACCOUNT,
    DELETE_ACCOUNT,
    GET_GROUP_ROLE,
    CREATE_GROUP_ROLE,
    EDIT_GROUP_ROLE,
    DELETE_GROUP_ROLE,
    MANAGER_CONFIG_SYSTEM,
    MANAGER_HISTORY,
    EDIT_CONTENT_LANDINGPAGE,
    FUNCTIONS,
}
